import { Trans } from "@lingui/react/macro";
import { Button, ButtonVariant } from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import React from "react";
import { stringPresent } from "src/utils/strings";
import { SectionSliderItem } from "./SectionSlider";
import * as styles from "./SectionSliderCaption.module.scss";

type Props = {
  currentSlideIndex: number;
  items: SectionSliderItem[];
  cardButtonVariant?: ButtonVariant;
  cardButtonLabel?: string;
};
const SectionSliderCaption: React.FC<Props> = ({
  items,
  currentSlideIndex,
  cardButtonVariant = "text",
  cardButtonLabel
}) => {
  const item = items[currentSlideIndex];
  if (!item) return null;

  return (
    <div className={styles.container} data-content-name={item.trackingName}>
      <div className={styles.title}>{item.title}</div>
      {item.subtitle && <div className={styles.subtitle}>{item.subtitle}</div>}
      <div className={styles.description}>
        <BlockContent value={item?.description} />
      </div>
      {item?.url && (
        <Button
          dataContentPiece="more_button"
          variant={cardButtonVariant}
          href={item.url}
          className={styles.cta}
        >
          {stringPresent(cardButtonLabel) ? (
            <React.Fragment>{cardButtonLabel}</React.Fragment>
          ) : (
            <Trans id="cta-discover-more">Discover more</Trans>
          )}
        </Button>
      )}
    </div>
  );
};

export default SectionSliderCaption;
